import { Inject, Injectable } from "@angular/core";
import { Operador } from "./clases/Operador";
import { BehaviorSubject } from "rxjs";
import { Condicion } from "./clases/Condicion";
import { ModalService } from "@shared/services";
import { CondicionesToken, OperadoresToken } from "@shared/tokens";

@Injectable({
    providedIn: "root"
})
export class CondicionesService {
    public operadores$: BehaviorSubject<Operador[]> = new BehaviorSubject(this.operadores);
    public condiciones$: BehaviorSubject<Condicion[]> = new BehaviorSubject(this.condiciones);

    constructor(private modalService: ModalService, @Inject(OperadoresToken) private operadores: Operador[],
        @Inject(CondicionesToken) private condiciones: Condicion[]) {}
}
